import React from "react";

export default function FormSelect({ label, helper, dir = "rtl", options = [], className = "", ...props }) {
  return (
    <label className="field-wrap">
      {label ? <span className="field-label">{label}</span> : null}
      <select
        className={[
          "field-select",
          dir === "ltr" ? "input-ltr" : "input-rtl",
          className
        ]
          .filter(Boolean)
          .join(" ")}
        {...props}
      >
        {options.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      {helper ? <span className="field-help">{helper}</span> : null}
    </label>
  );
}
